const PHONE = '561-445-3948';

const reasons = [
  {
    icon: 'ri-calendar-check-line',
    title: 'Fast Turnaround',
    desc: 'Same-week scheduling available. We work around your schedule, not the other way around.',
  },
  {
    icon: 'ri-shield-line',
    title: 'No Damage Methods',
    desc: 'Soft-wash technology for roofs and delicate surfaces. Zero risk to your tiles, screens, or paint.',
  },
  {
    icon: 'ri-timer-line',
    title: 'Reliable Scheduling',
    desc: 'We show up on time, every time. No waiting around for a crew that ghosted you.',
  },
  {
    icon: 'ri-map-pin-2-line',
    title: 'Local South Florida Business',
    desc: 'Based right here in South Florida. We know the climate, the HOA requirements, and the stains.',
  },
  {
    icon: 'ri-verified-badge-line',
    title: 'Licensed & Insured',
    desc: 'Fully licensed and insured in Florida. You\'re protected. We\'re accountable.',
  },
  {
    icon: 'ri-file-list-3-line',
    title: 'Free Estimates Always',
    desc: 'No obligation, no pressure. Get a clear honest quote before we touch anything.',
  },
];

export default function WhyChooseUs() {
  return (
    <section id="why-us" className="py-16 lg:py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left: Content */}
          <div>
            <span className="inline-block bg-teal-100 text-teal-700 text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-5">
              Why Choose Us
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-slate-900 mb-5">
              South Florida's Most Reliable Cleaning Pros
            </h2>
            <p className="text-slate-500 text-lg leading-relaxed mb-8">
              We don't cut corners. We don't damage surfaces. We show up when we say we will
              and we leave your property looking better than the day you moved in.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
              {reasons.map((r) => (
                <div key={r.title} className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-teal-100 shrink-0 mt-0.5">
                    <i className={`${r.icon} text-teal-600 text-lg`}></i>
                  </div>
                  <div>
                    <p className="font-bold text-slate-800 text-sm mb-0.5">{r.title}</p>
                    <p className="text-slate-500 text-xs leading-relaxed">{r.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="#contact"
                className="bg-orange-500 hover:bg-orange-600 text-white font-black px-7 py-3.5 rounded-lg transition-colors cursor-pointer whitespace-nowrap text-center"
              >
                Get Free Estimate
              </a>
              <a
                href={`tel:${PHONE}`}
                className="flex items-center justify-center gap-2 border-2 border-teal-600 text-teal-700 font-bold px-7 py-3.5 rounded-lg hover:bg-teal-50 transition-colors cursor-pointer whitespace-nowrap"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-fill text-teal-600 text-base"></i>
                </div>
                Call {PHONE}
              </a>
            </div>
          </div>

          {/* Right: Image */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden h-96 lg:h-[520px] w-full">
              <img
                src="https://public.readdy.ai/ai/img_res/6ccf0986c5ff27829c6fdc52a8a37507.jpg"
                alt="Professional pressure washing team South Florida"
                title="Licensed insured pressure washing team near me"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Floating badge */}
            <div className="absolute -bottom-4 -left-4 bg-white border border-gray-200 rounded-xl p-4 flex items-center gap-3">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-teal-600">
                <i className="ri-home-smile-2-fill text-white text-xl"></i>
              </div>
              <div>
                <p className="font-black text-slate-900 text-2xl leading-none">500+</p>
                <p className="text-slate-500 text-xs mt-0.5">Homes Cleaned in South FL</p>
              </div>
            </div>
            <div className="absolute -top-4 -right-4 bg-orange-500 rounded-xl p-4 text-center">
              <p className="text-white font-black text-sm">FREE</p>
              <p className="text-white/80 text-xs">Estimates</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
